export default __webpack_public_path__ + "static/media/toggleOuter.9dac118a.svg";